<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    id?: string;
    title?: string;
    modelValue?: string | number | null;
    readonly?: boolean;
    type?: string;
  }>(),
  {
    modelValue: null,
    readonly: false,
    type: "text",
  },
);

const emit = defineEmits<{
  "update:modelValue": [value: string | number | null];
}>();

const innerValue = computed<string | number | null>({
  get: () => props.modelValue,
  set: (value) => {
    if (props.type === "number") {
      emit("update:modelValue", value === "" ? null : Number(value));
      return;
    }
    emit("update:modelValue", value);
  },
});
</script>

<template>
  <div class="flex flex-col gap-1">
    <label
      :data-allow-mismatch="id"
      class="font-semibold text-gray-800 text-sm"
    >
      {{ title }}
    </label>
    <div
      class="flex flex-row items-center w-full px-3 py-2 border border-gray-300 rounded-lg focus-within:border-primary focus-within:shadow-[0_0_0_3px_rgba(31,168,91,0.12)]"
      :class="[
        readonly
          ? 'bg-gray-100! border! border-gray-300! text-gray-500! cursor-not-allowed!'
          : '',
      ]"
    >
      <slot></slot>
      <textarea
        class="w-full px-3 focus:outline-none"
        :id="id"
        v-bind="$attrs"
        :type="type"
        v-model="innerValue"
        :readonly="readonly"
      />
    </div>
  </div>
</template>
